"use client";

// import Note from "../Note";
import Button from "../SecondaryButton";
import Modal from "./Modal";
import CheckIcon from "@/assets/check-mark.svg";
import { isStakingDeprecated } from "@/config";

interface IProps {
  close: () => void;
  isOpen: boolean;
  amount: string;
  apyPercent: number;
}

const StakeSuccessfulModal = ({
  close,
  isOpen,
  amount,
  apyPercent,
}: IProps) => {
  return (
    <Modal close={close} isOpen={isOpen} className="w-[90%] md:w-[660px]">
      <div className="flex flex-col gap-7 text-white text-center items-center">
        <div className="flex flex-col gap-4 items-center">
          <div className="flex flex-col gap-8 items-center">
            <CheckIcon className="w-20 h-20" />
            <span className="font-albert-sans text-2xl leading-7 uppercase">
              You&apos;ve successfully staked!
            </span>
          </div>
          <p className="text-base leading-5">
            {isStakingDeprecated
              ? "Your tokens are staked. You can unstake them whenever you're ready."
              : "Your tokens are now earning rewards. You can claim accumulated rewards anytime or unstake when you're ready."}
          </p>
        </div>
        <div className="w-full py-4 flex flex-row justify-around border border-white border-opacity-[0.12] bg-white/5">
          <div className="flex flex-col gap-2 text-center items-center">
            <span className="text-2xl font-semibold">{amount}</span>
            <span className="text-sm">Amount Staked</span>
          </div>
          {!isStakingDeprecated && (
            <div className="flex flex-col gap-2 text-center items-center">
              <span className="text-2xl font-semibold">{apyPercent}%</span>
              <span className="text-sm">Current APY</span>
            </div>
          )}
        </div>

        {/* <Note
          title="⚠️️️ Important Note"
          description={
            <>
              Your unstaked tokens are in the{" "}
              <span className="font-bold text-white">
                14-days cooldown period
              </span>
              . After this period ends, you'll be able to withdraw your SPON.
            </>
          }
          cardClassname="text-left"
        /> */}
        <Button className="w-max" variant="light" onClick={close}>
          <div className="px-5">
            {isStakingDeprecated ? "CLOSE" : "CHECK STAKING REWARDS"}
          </div>
        </Button>
      </div>
    </Modal>
  );
};

export default StakeSuccessfulModal;
